var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLanguageIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.75H15.75M9 3.5V5.75M12.75 21.5L17.25 11L21.75 21.5M14.1328 18.5H20.3672M13.1859 5.75C13.1859 5.75 12.0469 10.1562 9.32812 13.4844C6.60938 16.8125 3.75 18.5 3.75 18.5",
    stroke: "#525059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.25C12 16.25 10.3594 14.9844 8.625 12.7344C6.89062 10.4844 6 8.75 6 8.75",
    stroke: "#525059",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLanguageIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LanguageIcon.8dd1b121.svg";
export { ForwardRef as ReactComponent };